import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

// Logs full HTTP error details to console.error while letting the error propagate.
export const errorLogInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse) {
        const payload = err.error;
        const traceId =
          (payload && typeof payload === 'object' && 'traceId' in payload
            ? (payload as { traceId?: string }).traceId
            : undefined) ?? null;
        const errorCode =
          (payload && typeof payload === 'object' && 'errorCode' in payload
            ? (payload as { errorCode?: string }).errorCode
            : undefined) ?? null;
        console.error(
          `[HTTP ${err.status}] ${req.method} ${req.url}`,
          { errorCode, traceId, payload, statusText: err.statusText },
        );
      } else {
        console.error('[HTTP] Non-HttpErrorResponse error', err);
      }
      return throwError(() => err);
    }),
  );
};
